import React from "react";
import { imageUrl } from "../util";
import NoteDisplay from "./NoteDisplay";
import ChampIcon from "../Champ.svg";
import * as cx from "classnames";

const Empty = () => <></>;

class ScreenshotItem extends React.Component {
  state = {
    loading: true,
    user: null,
    authed: false,
    start: 0,
    more: {},
  };
  moveLeft = e => {
    e.stopPropagation();
    e.preventDefault();
    let newStart = this.state.start;

    if (newStart > 0) {
      this.setState({
        start: newStart - 1,
      });
    }
  };
  moveRight = e => {
    e.stopPropagation();
    e.preventDefault();
    let newStart = this.state.start;

    if (newStart < this.props.screenshots.length - 1) {
      this.setState({
        start: newStart + 1,
      });
    }
  };
  render() {
    const { screenshots, isAdminPage, type, id } = this.props;
    const { start } = this.state;

    return (
      <>
        {screenshots.length > 2 && (
          <>
            {start > 0 && (
              <div className="arrow arrow-left pointer">
                <div
                  style={{
                    height: "50px",
                    width: "50px",
                    fontWeight: "bold",
                    fontSize: "30px",
                    color: "blue",
                  }}
                  onClick={this.moveLeft}
                >
                  {" "}
                  &lt;{" "}
                </div>
              </div>
            )}
            {start < screenshots.length - 2 && (
              <div className="arrow arrow-right pointer">
                <div
                  style={{
                    height: "50px",
                    width: "50px",
                    fontWeight: "bold",
                    fontSize: "30px",
                    color: "blue",
                  }}
                  onClick={this.moveRight}
                >
                  {" "}
                  &gt;{" "}
                </div>
              </div>
            )}
          </>
        )}
        <div
          className={cx({
            "shot-container": true,
          })}
        >
          <div
            className="mt2 tl flex arrow-container mb3"
            style={{ position: "relative", zIndex: 2 }}
          >
            {screenshots.map((s, i) => {
              let varNum = i;

              if (i > 0 && screenshots[i - 1].control) {
                varNum = i - 1;
              }
              if (i < start || i > start + 2) {
                return <></>;
              }
              let notes = null;
              let count = 0;
              let stop = 3;
              if (s.notes && s.notes.length) {
                s.notes.forEach((n, y) => {
                  if (!n || n.trim() === "") {
                    if (s.pos && s.pos[y]) {
                      delete s.pos[y];
                    }
                  }
                });
                notes = s.notes.filter(n => n && n.trim() !== "");
              }
              let poses = null;
              if (s.pos && s.pos.length) {
                poses = s.pos.filter(p => p !== undefined || p !== null);
              }

              return (
                <div
                  className={cx({
                    "screenshotItem-box mr3": true,
                    "ss-first": i === 0,
                  })}
                  key={`ssi_${id}_${i}`}
                >
                  <a href={this.props.url} className="ui-link db center">
                    <img
                      className="img-box br2 center"
                      src={imageUrl(s.src, type === "mobile" ? 400 : 675, 800)}
                      alt="screenshot"
                    />
                  </a>
                  {notes && (
                    <div className="screenshotItem-bottom">
                      <div
                        className={cx({
                          "f6 tc-s screenshotItem-notesHeader": true,
                          "screenshotItem-notesHeader-green": s.champ,
                        })}
                      >
                        <span>
                          {s.control ? "Control" : `Variant ${varNum + 1}`}
                        </span>
                        {isAdminPage && <> &mdash; {s.weight}</>}
                        {s.champ && (
                          <img
                            src={ChampIcon}
                            alt="Champ"
                            className="screenshotItem-icon"
                          />
                        )}
                      </div>
                      <div className="screenshotItem-notes">
                        {notes.map((n, x) => {
                          if (x >= stop && stop !== 0) {
                            return <Empty key={`empty_${id}_${i}_${x}`} />;
                          }
                          return (
                            <div
                              className={cx({
                                "note-odd": x % 2 !== 0,
                              })}
                              key={`note_${id}_${i}_${x}`}
                            >
                              <NoteDisplay
                                key={`${i}-${n}`}
                                text={n}
                                pos={poses && poses[x] ? poses[x] : null}
                                isAdminPage={this.props.isAdminPage}
                                company={this.props.company}
                              />
                            </div>
                          );
                        })}
                        {notes.length > stop && (
                          <div className="f7 pa2 tc">
                            <a
                              href={this.props.url}
                              className="ui-link db center dww-gray"
                            >
                              +{notes.length - stop} more
                            </a>
                          </div>
                        )}
                      </div>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </>
    );
  }
}
export default ScreenshotItem;
